@if (isConfigLoaded) {
  <div>
    <app-shell> </app-shell>
  </div>
}

@if (!isConfigLoaded && configService.loadFailed) {
  <div class="configuration-error" role="alert">
    <p>{{ dataService.getTexts().OrganizationConfigurationLoadFailed }}</p>
    <button pButton type="button" (click)="retry()">{{ dataService.getTexts().OnboardingButtonRetry }}</button>
  </div>
}

@if (!isConfigLoaded && !configService.loadFailed) {
  <div style="height: 90vh; display: flex; align-items: center; justify-content: center">
    <div style="display: flex; flex-direction: column; align-items: center">
      <div class="spinner icon-spinner-5" aria-hidden="true"></div>
      <div style="margin-top: 8px" class="shimmer">{{ dataService.getTexts().RequestWaitMessage }}</div>
    </div>
  </div>
}
